/**
 * defa.views.SubscriptionTransferForm
 * A simple form for transferring a subscription to a new email.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/subscriptionTransferForm.jst.html'

const selectors = {
	inputEmail: '[data-input=transfer-email]',
};

const SubscriptionTransferForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		email: selectors.inputEmail,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let email = this.ui.email.val().trim();
		this.model.transfer( email );
	},
	
} );

export default SubscriptionTransferForm;